/**
 * Vorschlag für den Dokumenttitel aus einem Dateinamen: Endung entfernen,
 * Unterstriche zu Leerzeichen glätten. Der vergebene Titel bleibt editierbar —
 * der rohe Dateiname erscheint nirgends in der Oberfläche oder auf Nachweisen.
 */
export function titleFromFileName(fileName: string): string {
  return fileName
    .replace(/\.[^.]+$/, '')
    .replace(/_+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
